export const currency = () => localStorage.getItem("currency")?localStorage.getItem("currency"):"₹";

export const sessionId = () => getCookie("USER_TOKEN");

export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
};
export const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName == name) {
        return decodeURIComponent(cookieValue);
        }
    }
    return null;
};


